import { ChangeDetectorRef, Component, inject, ChangeDetectionStrategy } from '@angular/core';
//import { TermRoutes } from 'src/app/enums/TermsEnum';
import { CheckVersionService } from '../../services/check-version.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [],
})
export class FooterComponent {
  version: string = '--';
  d = new Date().getFullYear();

  //privacity = new TextWithLink("Política de privacidad", TermRoutes.PRIVACY_POLICY.url);
  //terms_conditions = new TextWithLink("Términos y condiciones", TermRoutes.USE_CONDITIONS.url);
  //advice = new TextWithLink("Aviso legal", TermRoutes.LEGAL_ADVICE.url);

  checkVersonS: CheckVersionService = inject(CheckVersionService);
  cdRef: ChangeDetectorRef = inject(ChangeDetectorRef);

  ngAfterViewInit() {
    // Cargar después de la inicialización
    setTimeout(() => {
      this.checkVersonS.checkVersion().subscribe((version) => {
        this.version = version;
        this.cdRef.detectChanges();
      });
    });
  }
}
